import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";
import "../remediationDocumentStyles.css";
import { Button } from "@material-ui/core";

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: 0,
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    marginTop: 0,
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 4,
      borderColor: "#74b44a",
      boxShadow: 0,
      outline: 0,
    },
  },
}))(InputBase);

const ColorButton = withStyles((theme) => ({
  root: {
    color: "#ED1B23",
    backgroundColor: "#FFF0F0",
    borderColor: "#ED1B23",
    padding: "7px 15px",
    textTransform: "capitalize",
    "&:hover": {
      color: "white",
      backgroundColor: "#ED1B23",
    },
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function MainFilters(props) {
  const classes = useStyles();
  const {
    data,
    mainFilters,
    approveStatus,
    setMainFilters,
    hasUnapprovedItems,
    setShowConfirmation,
  } = props;

  const handleChange = (event) => {
    setMainFilters(event.target.value);
  };
  return (
    <div className="finterInnerCnt">
      <FormControl className={classes.margin}>
        <InputLabel
          htmlFor="demo-customized-select-native"
          style={{ display: "none" }}
        ></InputLabel>
        <NativeSelect
          id="demo-customized-select-native"
          value={mainFilters}
          onChange={handleChange}
          input={<BootstrapInput />}
        >
          {data?.map((item, index) => (
            <option value={item.value}>{item.label}</option>
          ))}
        </NativeSelect>
      </FormControl>

      <ColorButton
        variant="outlined"
        disabled={approveStatus || !hasUnapprovedItems}
        className={classes.margin}
        onClick={() => setShowConfirmation({ all: true })}
      >
        Delete All Unapproved
      </ColorButton>
    </div>
  );
}
